import type { DocEntityNode } from "./docEntityNode";
import { docEntityReferenceTargetsEntity } from "./docSchemaForeignKeyUtils";

/**
 * Filters `getReferences()` for forward doc-ref traversal. Drops a reference only when every FK
 * path to it is in `excludeReferenceFieldPaths`; does not mutate `getReferences()` itself.
 */
export function getDocRefTraversalReferenceNodes(
  node: DocEntityNode,
  excludeReferenceFieldPaths: ReadonlySet<string> | undefined,
): DocEntityNode[] {
  const references = node.getReferences();
  if (!excludeReferenceFieldPaths || excludeReferenceFieldPaths.size === 0) {
    return references;
  }

  const fkReferences = node.getForeignKeyReferences();

  return references.filter((referenceNode) => {
    let referencedByExcludedPathOnly = false;

    for (const fkReference of fkReferences) {
      if (!docEntityReferenceTargetsEntity(fkReference, referenceNode.getEntityType(), referenceNode.getId())) {
        continue;
      }
      if (!excludeReferenceFieldPaths.has(fkReference.fieldPath)) {
        return true;
      }
      referencedByExcludedPathOnly = true;
    }

    return !referencedByExcludedPathOnly;
  });
}
